import React from "react";
import { CommonColors } from "../../../types/colors";
import { twMerge } from "tailwind-merge";

export interface LoadingProps {
  className?: string;
  color?: CommonColors;
  svgClassName?: string;
  isSmall?: boolean;
}

const STYLES = {
  primary: "text-primary-500 fill-primary-25",
  success: "text-success-600 fill-success-50",
  error: "text-error-700 fill-error-50",
  info: "text-info-500 fill-info-50",
  warning: "text-warning-600 fill-warning-50",
};

export function SupLoader({ color = "primary", className = "", svgClassName = "", isSmall = false }: LoadingProps) {
  return (
    <div className={twMerge("flex mx-auto max-w-fit items-center h-auto", className)}>
      {isSmall ? (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={twMerge("self-center w-full h-full", STYLES[color], svgClassName)}
        >
          <path
            d="M4.86551 12.0869L2.26359 14.6889L0.353552 12.7788L2.95552 10.1768C3.82883 9.30352 4.95452 8.83397 6.10095 8.76637L6.74738 8.72824L6.24303 8.32209C5.87396 8.02486 5.40475 7.84515 4.89389 7.84515H1.21401V5.14381H4.89389C6.12893 5.14381 7.25692 5.60781 8.11534 6.37062L8.59929 6.80068L8.52997 6.15698C8.47922 5.68579 8.27442 5.22684 7.91326 4.86557L7.91324 4.86554L5.31126 2.26355L7.22125 0.353554L9.82322 2.95554C10.6965 3.82885 11.1661 4.95464 11.2337 6.10098L11.2718 6.74723L11.6779 6.2431C11.9753 5.87397 12.1549 5.40473 12.1549 4.89381V1.21402H14.8562V4.89392C14.8562 6.12895 14.3921 7.25705 13.6293 8.11538L13.1992 8.59934L13.843 8.53001C14.3142 8.47926 14.773 8.27444 15.1344 7.9132L15.1344 7.91317L17.7364 5.31119L19.6464 7.22129L17.0445 9.82327C16.1712 10.6966 15.0454 11.166 13.8991 11.2336L13.2528 11.2717L13.7569 11.6779C14.1261 11.9753 14.5954 12.1548 15.1062 12.1548H18.786V14.8562H15.1062C13.8712 14.8562 12.7431 14.3921 11.8847 13.6293L11.4007 13.1992L11.47 13.8429C11.5208 14.3142 11.7256 14.7731 12.0867 15.1343L12.0868 15.1344L14.6888 17.7363L12.7787 19.6465L10.1766 17.0445C10.1766 17.0445 10.1766 17.0445 10.1766 17.0445C9.30337 16.1711 8.83383 15.0454 8.76632 13.899L8.72826 13.2527L8.32207 13.7569C8.02469 14.126 7.84511 14.5953 7.84511 15.1062V18.7861H5.14379V15.1062C5.14379 13.8711 5.60778 12.7431 6.37049 11.8848L6.80053 11.4009L6.15684 11.4702C5.68567 11.5209 5.22681 11.7256 4.86551 12.0869Z"
            stroke="currentColor"
            strokeWidth="0.5"
            strokeDasharray="0,0,98.29809033203125,32.417455322265624"
          >
            <animate
              attributeType="XML"
              attributeName="stroke-dasharray"
              repeatCount="indefinite"
              dur="1.7241379310344827s"
              values="0,0,98.29809033203125,32.417455322265624;
          0,32.417455322265624,98.29809033203125,0;
          98.29809033203125,32.417455322265624,0,0"
              keyTimes="0; 0.248; 1"
              begin="0.26201600315247364s"
            ></animate>
          </path>
        </svg>
      ) : (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={twMerge("self-center w-full h-full", STYLES[color], svgClassName)}
        >
          <path
            d="M9.9078 24.3506L4.52718 29.7313L0.353553 25.5576L5.73427 20.1769C7.52605 18.3851 9.83592 17.4218 12.1872 17.2832L12.8336 17.245L12.3293 16.8389C11.6334 16.2785 10.7498 15.9403 9.78778 15.9403H2.17802V10.0376H9.78778C12.3217 10.0376 14.6362 10.9899 16.3967 12.5544L16.8807 12.9844L16.8114 12.3407C16.7157 11.4524 16.3299 10.5883 15.6497 9.90788L15.6497 9.90785L10.269 4.52711L14.4425 0.353554L19.8232 5.7343C21.615 7.52608 22.5783 9.83617 22.7169 12.1872L22.755 12.8335L23.1612 12.3294C23.7218 11.6335 24.0598 10.7498 24.0598 9.78763V2.17803H29.9624V9.78783C29.9624 12.3218 29.01 14.6364 27.4455 16.3968L27.0154 16.8808L27.6591 16.8115C28.5475 16.7158 29.4114 16.3299 30.092 15.6496L30.092 15.6496L35.4727 10.2688L39.6464 14.4426L34.2657 19.8233C32.474 21.6151 30.1639 22.5782 27.8128 22.7168L27.1666 22.7549L27.6707 23.1611C28.3666 23.7217 29.2504 24.0597 30.2124 24.0597H37.822V29.9624H30.2124C27.6785 29.9624 25.3638 29.0099 23.6032 27.4454L23.1193 27.0154L23.1886 27.6591C23.2843 28.5476 23.6701 29.4115 24.3503 30.0919L24.3503 30.0919L29.7312 35.4727L25.5575 39.6465L20.1764 34.2657C18.3848 32.4739 17.4215 30.1638 17.2831 27.8128L17.245 27.1664L16.8388 27.6706C16.2782 28.3665 15.9402 29.2502 15.9402 30.2124V37.8222H10.0376V30.2124C10.0376 27.6784 10.9898 25.3639 12.5541 23.6036L12.9841 23.1196L12.3405 23.1889C11.4522 23.2846 10.5882 23.6702 9.9078 24.3506Z"
            stroke="currentColor"
            strokeWidth="0.5"
            strokeDasharray="0,0,199.04144531250003,60.127103271484344"
          >
            <animate
              attributeType="XML"
              attributeName="stroke-dasharray"
              repeatCount="indefinite"
              dur="1.7241379310344827s"
              values="0,0,199.04144531250003,60.127103271484344;
          0,60.127103271484344,199.04144531250003,0;
          199.04144531250003,60.127103271484344,0,0"
              keyTimes="0; 0.23199999999999987; 1"
            />
          </path>
        </svg>
      )}
      <span className="sr-only">Loading...</span>
    </div>
  );
}
